




















    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import { VFields } from '@/models/v-fields';
    import { Department } from '@/models/admin/department';
    import { Base } from '@/components/common/base';
    import { departmentService,storeService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

    @Component({
        props: ['methodName', 'progress'],
        computed: {
            methodtoCall: {
                get() {
                    return this.$props.methodName;
                },
            },
        },
    })
    export default class DepartmentSavePage extends Base {
        public stores: any[];
        public department: Department = {
            id: '',
            name: '',
            storeId: 0,
            description: '',
        };
        public form: any = {};
        public formFields: Array<VFields<any>> = [];
        public storeId: any = 0;
        public paymentTypes: any[];
        public disableSubmitButton: boolean = false;

        public unlinkedDepartments: any;

        public beforeDestroy() {
            const buttons = [];
            this.$emit('updateToolBar', buttons);
        }
        public callMethod(methodName): void {
            if (methodName === 'backToList') {
                this.$router.push({ name: 'admin.departments', params: { storeId: this.storeId } });
            }
            if (methodName === 'submit') {
                if (!this.form.$valid) {
                    this.showAlert(false, 'Form is Invalid!');
                    this.resetMethodName(methodName);
                    return;
                }
                this.submitDepartment();
            }
            this.resetMethodName(methodName);
        }
        public resetMethodName(methodName): void {
            if (methodName !== '') {
                this.$emit('resetMethodName', methodName);
            }
        }
        public updateToolBar(): void {
            const buttons: any = [];
            if (this.storeId) {
                buttons.push({ id: '0', type: 'button', title: this.$parent.$t('departments.btnBack'), disabled: false, visible: true, class: 'btn', label: this.$parent.$t('departments.btnBack'), click: 'backToList', icon: 'fas fa-arrow-left' });
            }
            this.$emit('updateToolBar', buttons);
        }
        public async mounted(): Promise<void> {
            // activating tab
            this.$root.$emit('sidebar.layout.vue', 'departments');

            this.setFields();
            this.storeId = String(this.$route.params.storeId);
            this.department.storeId = this.storeId;
            this.getDepartments();
            if (this.$route.params.id) {
                const department = await departmentService.getAsync(
                    this.$route.params.id,
                    this.storeId,
                );
                this.department = department;
                this.department.storeId = department.storeId.toString();
            }
            this.updateToolBar();
            this.$watch('methodtoCall', (newVal, oldVal) => {
                if (newVal) {
                    this.callMethod(newVal);
                }
            });
            this.getStores();
        }

        public validateDepartment(): Vue & { validate: () => boolean } {
            return this.$refs.departmentForm as Vue & { validate: () => boolean };
        }


        public async submitDepartment(): Promise<void> {
            if(this.validateDepartment().validate()){
                try {
                    this.disableSubmitButton = true;
                    this.$emit('update:progress', this.disableSubmitButton);
                    if (this.$route.params.id) {
                        try {
                            await departmentService.updateDepartmentAsync(
                                this.department,
                                this.storeId,
                            );
                            this.showAlert(true, this.$t('departments.alertUpdateDepartment'));
                            this.$router.push({
                                name: 'admin.departments',
                                params: { storeId: this.storeId.toString() },
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    } else {
                        try {
                            await departmentService.saveDepartmentAsync(
                                this.department,
                                this.storeId,
                            );
                            this.showAlert(true, this.$t('departments.alertSaveDepartment'));
                            this.$router.push({
                                name: 'admin.departments',
                                params: { storeId: this.storeId.toString() },
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    }
                } finally {
                    this.disableSubmitButton = false;
                    this.$emit('update:progress', this.disableSubmitButton);
                }
            }
        }
        public setFields(): void {
            this.formFields = [
                {
                    key: 'storeId',
                    type: 'v-alynk-select',
                    required: true,
                    templateOptions: {
                        counter: 500,
                        label: this.$t('departments.departmentFields.StoreName') as string,
                        disabled: true,
                        items: this.stores,
                        text: 'dealershipName',
                        value: 'id',
                        altag: 'Select Store',
                        loading: false,
                        rules: [
                            v => this.required('Store Name',v)
                        ]
                    },
                },
                {
                    key: 'id',
                    type: 'v-alynk-select',
                    required: true,
                    templateOptions: {
                        label: this.$t('departments.departmentFields.department') as string,
                        required: true,
                        disabled: false,
                        items: this.unlinkedDepartments,
                        text: 'name',
                        value: 'name',
                        altag: 'Department',
                        loading: false,
                        rules: [
                            v => this.required('Department',v)
                        ]
                    },
                },
            ];
        }
        public async getStores(): Promise<void> {
            const stores = await storeService.getStoresList();
            this.stores = stores.results;
            this.storeId = String(this.$route.params.storeId);
            this.formFields[0].templateOptions.items = this.stores;
        }
        public async getDepartments(): Promise<void> {
            try {
                this.formlyShowSkeleton(this.formFields);
                const unlikedDepartments = await departmentService.getUnlinkedDepartmentsAsync(
                    this.storeId,
                );
                this.unlinkedDepartments = unlikedDepartments;
                this.formFields[1].templateOptions.items = unlikedDepartments;
            } finally {
                this.formlyHideSkeleton(this.formFields);
            }
        }
    }
